<button (click)="buttonClick.emit()" [style]="buttonStyle">
  <img src="assets/img/icons/plus-orange.svg" />
  <ng-content></ng-content>
</button>
